/**
 * Region Type Constants
 * 
 * Defines visual styling and behavior for different musical region types.
 */

/**
 * Region type definitions with associated colors
 */
export const REGION_TYPES = {
  RHYTHM: 'rhythm',
  BREAK: 'break',
  AMBIENCE: 'ambience',
  SOLO: 'solo',
  FREE: 'free',
  MELODY: 'melody',
  CHORDS: 'chords',
  HARMONY: 'harmony',
  BREAK_AUTO: 'break-auto', // Auto-generated breaks parse to 'break'
};

/**
 * Region color scheme mapping
 * Each region type has a background and border color
 */
export const REGION_COLORS = {
  [REGION_TYPES.RHYTHM]: {
    background: '#e51a4c',
    border: '#ff2b60',
  },
  [REGION_TYPES.BREAK]: {
    background: '#7c7c91',
    border: '#d3d3da',
  },
  [REGION_TYPES.AMBIENCE]: {
    background: '#00a693',
    border: '#04d0b8',
  },
  [REGION_TYPES.SOLO]: {
    background: '#5016ef',
    border: '#7e5ff2',
  },
  [REGION_TYPES.FREE]: {
    background: '#f7b000',
    border: '#ffdf80',
  },
  [REGION_TYPES.MELODY]: {
    background: 'rgb(119, 60, 28)',
    border: 'rgb(164, 99, 64)',
  },
  [REGION_TYPES.CHORDS]: {
    background: '#ef16d9',
    border: '#ff9af5',
  },
  [REGION_TYPES.HARMONY]: {
    background: '#ef16d9',
    border: '#ff9af5',
  },
};

/**
 * Region arrow types for multi-line spanning
 */
export const ARROW_TYPES = {
  RIGHT: 'r',      // Region continues to next line
  LEFT: 'l',       // Region continues from previous line
  BOTH: 'rl',      // Region has both continuations
  NONE: null,      // No arrows (region fits on one line)
};

/**
 * Knob parameter types and labels
 */
export const KNOB_TYPES = {
  DYNAMICS: { key: 'dynamics', label: 'D' },
  COMPLEXITY: { key: 'complexity', label: 'C' },
  FILLS: { key: 'fills', label: 'F' },
};

